export default {
  CREATE: `Create an attendance reason or a vacation type`,
  DELETE_BUTTON: {
    TITLE: `Delete the reason / type`,
    SUMMARY: `Are you sure you want to delete this reason / type?`,
    PRIMARY_ACTION: `Delete the reason / type`
  },
  LIST: {
    TITLE: `Attendance reason and vacation type management`,
    SUMMARY: ``
  },
  TYPE: `Type`,
  COUNT_HOURS: `Counts as worked hours`,
  CANNOT_BE_SELF_ASSIGNED: `Can't be self-assigned by user`,
  COUNT_IN_ABSENTEEISM_RATE: `Count in absenteeism rate`,
  IGNORE_IN_CONTACT_LIST: `Ignore in contact list`,
  DESCRIPTION_FR: `French description`,
  DESCRIPTION_EN: `English description`,
  IGNORE_RIGHT_REFUSE_WORK: `Ignore the right to refuse work`,
  HAS_MIN_DELAY_AFTER_ABSENCE: `Rest after the request`,
  MIN_DELAY_AFTER_ABSENCE: `Minimum rest after the request`,
  ALWAYS_SHOWN_IN_SCHEDULE: `Always shown in schedule`,
  LEAVEREASON: `Absence reason`,
  LATEREASON: `Departure reason`,
  EARLYOUTREASON: `Early out reason`,
  VACATIONTYPE: `Time off type`,
  CSV_EXPORT_NAME: `requestOptions_export_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Creating a type or reason`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a type or reason`,
      SUMMARY: ``
    },
    NAMEFR: {
      LABEL: `French name`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Enter a french name`
    },
    NAMEEN: {
      LABEL: `English name`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Enter an english name`
    },
    DESCRIPTIONFR: {
      LABEL: `French description`,
      DESCRIPTION: `This description will be shown to users during request creation.`,
      PLACEHOLDER: `Enter a description`
    },
    DESCRIPTIONEN: {
      LABEL: `English description`,
      DESCRIPTION: `This description will be shown to users during request creation`,
      PLACEHOLDER: `Enter a description`
    },
    EARNINGCODE: {
      LABEL: `Earning code`,
      DESCRIPTION: `This code will be used to export information to external pay systems and should also be defined in those systems.`,
      PLACEHOLDER: `Enter the earning code`
    },
    TYPE: {
      LABEL: `Type of request`,
      DESCRIPTION: `Determines what type of request this reason or type can be used for.`
    },
    CODE: {
      LABEL: `Import code`,
      DESCRIPTION: `This is used for import tools and certain integrations.`,
      PLACEHOLDER: `Enter an import code`
    },
    INDEX: {
      LABEL: `Call system index`,
      DESCRIPTION: `This index is used in the call system to present to the user the choices of reason of leave or delay in a specific order.`,
      PLACEHOLDER: `Enter a number equal or superior to 1`
    },
    COUNTHOURS: {
      LABEL: `Count as worked hours`,
      DESCRIPTION: `Counts the hours of requests using this type or reason towards worked hours.`
    },
    CANNOTBESELFASSIGNED: {
      LABEL: `Cannot be self-assigned`,
      DESCRIPTION: `Prevents users without proper permissions from self-assiging this type or reason.`
    },
    AUTOMATICALLYAPPROVED: {
      LABEL: `Approve automatically`,
      DESCRIPTION: `Time off requests of this type will be automatically approved.`
    },
    ALWAYSSHOWNINSCHEDULE: {
      LABEL: `Always shown in schedule`,
      DESCRIPTION: `This type of time off request is always shown in the schedule, even when the setting to view time off in schedule is off.`
    },
    COUNTINABSENTEEISMRATE: {
      LABEL: `Counts towards absenteeism`,
      DESCRIPTION: `Account for this type of request when calculating absenteeism percentage.`
    },
    IGNOREINCONTACTLIST: {
      LABEL: `Will be ignored for contact lists`,
      DESCRIPTION: `Someone using this reason or type will still be eligible to be contacted in contact lists`
    },
    IGNORERIGHTTOREFUSEWORK: {
      LABEL: `Ignore right to refuse work`,
      DESCRIPTION: `Someone using this reason will not trigger the warning that they were allowed to refuse this shift.`
    },
    HASMINDELAYAFTERABSENCE: {
      LABEL: `Unavailable after`,
      DESCRIPTION: `Creates a range after the request where the user is not available for another shift.`
    },
    MINDELAYAFTERABSENCE: {
      LABEL: `Unavailability after an absence (in minutes)`,
      DESCRIPTION: `A user submitting a request with this activated, will be ineligible for other shift for the amount of minutes entered after the end of the shift.`,
      PLACEHOLDER: `Enter the amount of time a user is ineligible after submitting an absence.`
    },
    PARTIALDAYBYDEFAULT: {
      LABEL: `Has specific start and end time`,
      DESCRIPTION: `When using quick assign, this request type will default to the chosen start and end time.`
    },
    DEFAULTSTARTTIME: {
      LABEL: `Default start time`,
      DESCRIPTION: ``
    },
    DEFAULTENDTIME: {
      LABEL: `Default end time`,
      DESCRIPTION: ``
    },
    NAME_REQUIRED: `The name is mandatory.`,
    TYPE_REQUIRED: `The type is mandatory.`
  }
}
